import React from 'react'
import PropTypes from 'prop-types'
import { ButtonOutline } from '../GeneralComponents/ButtonOutline/ButtonOutline'
import classes from './FeelsSyncConfirmation.module.css'

const MESSAGES = {
  transcribe: {
    title: 'Are you sure you want to transcribe?',
    buttonText: 'TRANSCRIBE',
    content: [
      "We'll attempt to transcribe the lyrics, but please check for accuracy afterward.",
      'You can add accurate lyrics by clicking "Edit Lyrics" first and send them out for timing.',
      'This process can take between 5-20 minutes.',
      "You can continue working on other tasks and return to this page once it's complete.",
    ],
  },
  feelsSync: {
    title: 'Are you sure you want to run FeelsSync?',
    buttonText: 'RUN FEELSSYNC',
    content: [
      'This will automatically retime your content, replacing all previous timing for this song. Manual adjustments may still be required.',
      'This process can take between 5-20 minutes.',
      "You can continue working on other tasks and return to this page once it's complete.",
    ],
  },
}

const FeelsSyncConfirmation = ({ onConfirm, onCancel, hasLyrics, hasUnsavedEdits }) => {
  const messages = hasLyrics ? MESSAGES.feelsSync : MESSAGES.transcribe
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <h3 className={classes.title}>
          {messages.title}
        </h3>

        <div className={classes.message}>
          {hasUnsavedEdits && (
            <p><strong>Your unsaved lyric edits will be saved first.</strong></p>
          )}
          {messages.content.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>
      </div>

      <div className={classes.actions}>
        <ButtonOutline
          text={messages.buttonText}
          color="green"
          size="small"
          onClick={onConfirm}
          className={classes.confirmButton}
        />
        <ButtonOutline
          text="CANCEL"
          color="pink"
          size="small"
          onClick={onCancel}
          className={classes.cancelButton}
        />
      </div>
    </div>
  )
}

FeelsSyncConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  hasLyrics: PropTypes.bool,
  hasUnsavedEdits: PropTypes.bool,
}

export default FeelsSyncConfirmation